import { Schema } from '@core/data/dto/schema';

export const PayScheduleSchema = {
    id: Schema.String,
    name: Schema.String,
    pay_frequency: Schema.Auto,
    active: Schema.Boolean
};
